var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated pulse",class:_vm.setButtonClass,style:(_vm.setButtonPosition),on:{"click":function($event){_vm.$emit('clicked')}}},[(_vm.href!=null)?_c('a',{class:_vm.cls,attrs:{"href":_vm.href}},[(_vm.material_icon)?_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.icon))]):_c('i',{class:_vm.icon})]):_c('div',{class:[
            _vm.cls
            ,
            _vm.material_icon?'material-design':''
    ]},[(_vm.material_icon)?_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.icon))]):_c('i',{class:_vm.icon})])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77e7455a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/Shared/Resources/Assets/js/components/buttons/FloatingButton.vue
// module id = lUTE
// module chunks = 0